document.addEventListener("DOMContentLoaded", () => {

  const reassuranceContainer = document.querySelector('.cv-bloc-reassurance');
  if (!reassuranceContainer) return;

  function initReassuranceSwipers() {
    const observer = new IntersectionObserver((entries, obs) => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      obs.unobserve(entry.target);

      const swiperReassurance = new Swiper('.swiper--reassurance', {
        loop: true,
        mousewheel: true,

        autoplay: {
          delay: 5000,
        },

        effect: 'slide',

        pagination: {
          el: '.swiper-pagination',
        },

        slidesPerView: 1,
        spaceBetween: 0,
        breakpoints: {
          // when window width is >= 320px
          320: {
            slidesPerView: 1,
            spaceBetween: 20
          },
          // when window width is >= 480px
          480: {
            slidesPerView: 2,
            spaceBetween: 30
          },
          // when window width is >= 640px
          640: {
            loop: false,
            autoplay: false,
            slidesPerView: 4,
            spaceBetween: 40,
            mousewheel: false,
          }
        }
      });

      console.log(swiperReassurance);

      const swiperReassuranceSlider = new Swiper('.swiper--reassurance-slider', {
        loop: true,
        mousewheel: true,
        width: 256,
        autoplay: {
          delay: 5000,
        },

        effect: 'slide',

        pagination: {
          el: '.swiper-pagination',
        },

        slidesPerView: 1,
        spaceBetween: 0,
        breakpoints: {
          // when window width is >= 320px
          320: {
            slidesPerView: 1,
            spaceBetween: 20
          },
        }
      });

      console.log(swiperReassuranceSlider);
    });
  }, { rootMargin: '300px 0px' });

    observer.observe(reassuranceContainer);
  }

  if (typeof Swiper !== 'undefined') {
    initReassuranceSwipers();
  } else {
    document.addEventListener('swiper:loaded', initReassuranceSwipers, { once: true });
  }
});
